define(
  ['marionette', 'underscore', 'perfect-scrollbar', './AvatarCard'],
  function (Marionette, _, Scrollbar, AvatarCard) {
    return Marionette.CollectionView.extend({
      tagName: 'ul',
      childView: AvatarCard,
      childViewOptions: {
        size: 'm'
      },
      options: {
        userItemRowHeight: 60
      },
      childEvents: {
        'user:select': 'onUserSelect'
      },
      onUserSelect: function (model) {
        this.trigger('user:select', model)
      },
      deselectCurrent: function () {
        var selected = this.collection.where({ selected: true })
        _.each(selected, function (model) {
          model.set('selected', false)
        })
      },
      getVisibleCollection: function () {
        return this.collection.where({ visible: true })
      },
      selectNext: function () {
        var collection = this.getVisibleCollection()
        var totalElems = collection.length

        this.deselectCurrent()
        this.currentSelected = this.currentSelected === totalElems - 1
          ? 0
          : this.currentSelected + 1
        this.updateSelection()
      },
      selectPrev: function () {
        var collection = this.getVisibleCollection()
        var totalElems = collection.length

        this.deselectCurrent()
        this.currentSelected = this.currentSelected === 0
          ? totalElems - 1
          : this.currentSelected - 1
        this.updateSelection()
      },
      selectFirst: function () {
        this.deselectCurrent()
        this.currentSelected = 0
        this.updateSelection()
      },
      updateSelection: function () {
        var selectedItem = this.collection.at(this.currentSelected)
        if (!selectedItem) return
        selectedItem.set('selected', true)
        Scrollbar.update(this.el)
        this.$el.stop().animate(
          {
            scrollTop: Math.round(
              (this.currentSelected - 2) * this.options.userItemRowHeight
            ) + 'px'
          },
          70
        )
      },
      onRender: function () {
        this.selectFirst()

        if (!this.hasScrollbar) {
          Scrollbar.initialize(this.el, {
            wheelPropagation: true,
            minScrollbarLength: 50
          })
          this.hasScrollbar = true
        }

        this.listenTo(this.collection, 'sync', this.selectFirst.bind(this))
      }
    })
  }
)
